import React from 'react';
import { Card } from './Card';
import { DoughnutChart } from '../charts/DoughnutChart';
import { Legend } from '../Legend';
import { ChartInput } from '../../model/ChartInput';
import { Information } from '../Information';
import { t } from '../../i18n';

const GenderCard = ({ input }: Props) => {
  return (
    <Card className="">
      <div className="card-body">
        <div className="row h-100">
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="d-flex align-items-center">
              <Information id="gender" content={<h5 className="card-title d-inline-block mb-2 mb-lg-0">{t('cards.gender')}</h5>} />
              <Information id="gender" showMore={true} className="ms-2" />
            </div>
            <div className="d-lg-flex align-items-center h-100">
              <div className="d-lg-flex flex-lg-column mb-2 mb-lg-0">
                <Legend color={'info'} label={t('gender.Male')} />
                <Legend color={'success'} label={t('gender.Female')} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <DoughnutChart datasets={input.datasets || []} labels={input.labels || []} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  input: ChartInput
}

export { GenderCard };